import { ref } from 'vue'
import { useApi } from '@/api/useApi'
import API from '@/api/apiUrls'
import { defineStore } from 'pinia'
import type { UserType } from '@/stores/type/authDjango.type'
import { useSearchUserBaseStore } from '@haskoning/vue-basestore'

const { api } = useApi()
const userIndex = API.CORE.USERS.INDEX
const currentUser = API.CORE.USERS.CURRENT_USER

export const useDjangoAuthStore = defineStore('auth', () => {
  const searchUserBaseStore = useSearchUserBaseStore<UserType>(api, userIndex)
  const user = ref<UserType | null>(null)
  const loginRedirect = ref<string | null>(null)

  async function authenticate({ email, password }: { email: string; password: string }) {
    await api.apiService.authenticationHandler.authenticate(email, password)
    const userResponse = await api.service(currentUser).get()
    user.value = userResponse
    return { user: userResponse }
  }

  async function reAuthenticate() {
    await api.apiService.authenticationHandler.setAccessTokenInHeaderFromStore()
    try {
      const userResponse = await api.service(currentUser).get()
      user.value = userResponse
      return { user: userResponse }
    } catch {
      user.value = null
      return { user: null }
    }
  }

  function logout() {
    localStorage.removeItem('access')
    localStorage.removeItem('refresh')
    user.value = null
    loginRedirect.value = null
  }

  return {
    ...searchUserBaseStore,
    user,
    loginRedirect,
    authenticate,
    reAuthenticate,
    logout
  }
})
